import { createContext, useState } from "react";

const defaultRootState = {
  sidebarOpened: false,
  welcomeBonusClosed: false,
  depositPromotionOpenTime: -1,
  invitePromotionOpenDay: -1,
};

// 创建一个 Context
export const RootStateContext = createContext(defaultRootState);

// 创建一个 DataProvider 组件
export const RootStateProvider = ({ children }) => {
  const [rootState, setRootState] = useState(defaultRootState);

  const setRootStateKey = (key, value) => {
    setRootState((previous) => ({ ...previous, [key]: value }));
  };

  return (
    <RootStateContext.Provider value={{ rootState, setRootState, setRootStateKey }}>
      {children}
    </RootStateContext.Provider>
  );
};
